"use client";

import type { AssetRotatorBlock } from "@mw/shared/payload-types";
import dynamic from "next/dynamic";

const BlockAssetRotator = dynamic(() => import("./BlockAssetRotator").then(mod => mod.BlockAssetRotator));

export const BlockAssetRotatorWrapper = (props: AssetRotatorBlock) => {
  return <BlockAssetRotator {...props} />;
};
